import ApiService from "@/core/services/api.service";
// action types
export const REQUIREMENT_LIST = "requirement/list";

// mutation types
export const SET_REQUIREMENT_LIST = "setRequirementList";
export const REQUIREMENT_REMOVE = "deleteRequirement";
export const REQUIREMENT_MODIFY = "modifyRequirement";
export const REQUIREMENT_CANCEL = "cancelRequest";

const state = {
    requirements: [],
};

const getters = {
    requirementsList(state) {
        return state.requirements;
    },
};

const mutations = {
    [SET_REQUIREMENT_LIST](state, requirements) {
        state.requirements = requirements;
    },

    [REQUIREMENT_REMOVE](state, requirementId) {
        let index = state.requirements.findIndex(value => value.id === requirementId);
        state.requirements.splice(index, 1);
    },

    [REQUIREMENT_MODIFY](state, requirementId) {
        let index = state.requirements.findIndex(value => value.id === requirementId)
        state.requirements[index].status = 1;
    },
    [REQUIREMENT_CANCEL](state, requirementId) {
        let index = state.requirements.findIndex(value => value.id === requirementId)
        state.requirements[index].is_cancel = 1;
    },
};

const actions = {
    [REQUIREMENT_LIST]({commit}) {
        ApiService.get("admin/requirements/all")
            .then(({data}) => {
                commit(SET_REQUIREMENT_LIST, data);
            })
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};